import React, {useState, useEffect} from 'react'
import {setCookie} from '../../cookies'
import './Login.css'
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import axios from 'axios'
import ErrorMsg from '../ErrorMsg/ErrorMsg'
import loadingIcon from '../../assets/loading_icon.gif'
import Navbar from '../Home/Navbar/Navbar'


const Login = (props) => {
    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
    const [error, setError] = useState('')

    // const END_POINT = 'http://localhost:4000'
    const END_POINT = 'https://barber-appointments.herokuapp.com'
    useEffect(()=>{
        console.log('Login Rendered')
    },[])

    const handleLogin = async () => {
        let logBtn = document.querySelector('#display-none-log-btn')
        let logLink = document.querySelector('#display-none-log-link')
        let loading = document.querySelector('.login-loading')
        loading.style.display = 'block'
        logBtn.style.display = 'none'
        logLink.style.display = 'none'

        let userData = {}
        userData.email = email
        userData.pass = pass

        let response = await axios.post('https://barber-appointments.herokuapp.com/login', userData)
        let {id, status, error, name, admin, phone} = response.data
        if(error){
            loading.style.display = 'none'
            logBtn.style.display = 'flex'
            logLink.style.display = 'block'
            setError(error)
            setTimeout( ()=>{
                setError('')
            },6000)
        }else{
            // need to check if the appointment date pass and delete it
            try{
                let currentTime = new Date().getTime()
                let checkAppointmentDate = 
                await axios.get(`${END_POINT}/userappointment?id=${id}`)
                let {error} = checkAppointmentDate.data
                if(error){
                    console.log(error)
                }
                else{
                    let appointmentTime = checkAppointmentDate.data.timeInMS
                    if(currentTime < appointmentTime){
                        console.log('dont forget you have appointment!')
                    }
                    else{
                        let expiredAppointment = 
                        await axios.post(`${END_POINT}/cancelappointment`,{id:id})
                    }
                }
            }catch(e){
                console.log(e)
            }
    
            loading.style.display = 'none'
            logBtn.style.display = 'flex'
            logLink.style.display = 'block'
            setCookie('id', id ,2)
            setCookie('status', status ,2)
            setCookie('name', name ,2)
            setCookie('admin', admin ,2)
            if(phone)
                setCookie('phone', phone ,2)
            setCookie('phone', 'phone...' ,2)

            if(admin)
                props.history.push({ pathname: '/admin' });
            else
                props.history.push({ pathname: '/appointment' });
        }
    }

    const loginByPress = (e) =>{
        if(e.key === 'Enter')
            handleLogin()
      }

    return (
        <div className='register'>
            <Navbar/>
            <div className='login-container'>
                <div className='register-form'>
                    <div className='register-info'>
                        <h1>Login</h1>
                        <img src={logo} alt=''></img>
                    </div>
                    <div className='form-container'> 
                    {error !== '' ?  <ErrorMsg info={error}/>
                        
                        : ''}
                        <p>Email:</p>
                        <input type="email" 
                            placeholder='Email...'
                            className='form-container-input'
                            name='email'
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                        <p>Password:</p>
                        <input type="password"
                            placeholder='Password...'
                            className='form-container-input'
                            name='password'
                            onChange={(e) => setPass(e.target.value)}
                            onKeyPress={(e) => loginByPress(e)}
                            value={pass}
                        />
                        <div id='display-none-log-btn' className='reg-btn-div'>
                            <button onClick={handleLogin} className='reg-submit'>Login</button>
                        </div> 
                        <div id='display-none-log-link' className='new-account-login'>
                            <Link to='/register' className='new-account-link'>
                                Do you have account?
                            </Link> 
                        </div>
                        <div className='login-div'>
                            <img className='login-loading' src={loadingIcon} alt=""/>
                        </div>         
                    </div>
                </div>
                <div className='register-img'></div>
            </div>  
        </div>
    )
}

export default Login
